import { fabric } from 'fabric';
import type Shape from '../objects/Shape';
import { resizeWithSmartGuides } from '../objects/SmartGuideBehaviors';
import LinearResizeControl, {
  type LinearResizeControlOptions,
} from './LinearResizeControl';

// The text shape has special behavior. Dragging horizontally puts it into a
// wrapping mode and changes width, rather than scaleX.
function wrapTextShapes(
  actionHandler: fabric.ActionHandler
): fabric.ActionHandler {
  return function (eventData, transform, x, y) {
    const target = transform.target as Shape;
    if (target.textProps.wrapText === 'user') {
      // Once the user changes the width then the text will always be wrapped.
      if (!target.wrapText) {
        target.set('wrapText', true);
      }

      return fabric.controlsUtils.changeWidth(eventData, transform, x, y);
    } else {
      return actionHandler(eventData, transform, x, y);
    }
  };
}

/**
 * Linear Resize Controls.
 *
 * Allows dragging of the bounding box edges for one dimensional resize.
 */
class ShapeLinearResizeControl extends LinearResizeControl {
  constructor(options: LinearResizeControlOptions) {
    super(options);

    if (this.edge === 'left' || this.edge === 'right') {
      this.actionHandler = resizeWithSmartGuides(
        wrapTextShapes(fabric.controlsUtils.scalingX),
        ['v']
      );
    } else if (this.edge === 'top' || this.edge === 'bottom') {
      this.actionHandler = resizeWithSmartGuides(
        fabric.controlsUtils.scalingY,
        ['h']
      );
    }
  }

  // Not available on uniform scaling objects
  getVisibility(fabricObject: Shape, controlKey: string) {
    if (
      !fabricObject.allowLinearEdgeScaling &&
      fabricObject.uniformScaling &&
      fabricObject.textProps.wrapText !== 'user'
    ) {
      return false;
    }

    if (
      fabricObject.textProps.wrapText === 'user' &&
      ['mt', 'mb'].includes(controlKey)
    ) {
      return false;
    }

    return super.getVisibility(fabricObject, controlKey);
  }
}

export default ShapeLinearResizeControl;
